@if (!!icon) {
  <celum-icon class="checkbox-item_icon" [class.checkbox-item_icon--additional-text]="additionalText" [clickable]="false" [configuration]="icon"></celum-icon>
}
@if (orientation === 'column') {
  <mat-checkbox
    class="checkbox-item_checkbox"
    name="{{ text | translate }}"
    [checked]="checked"
    [disabled]="disabled"
    [indeterminate]="indeterminate"></mat-checkbox>
}
@if (orientation === 'row' && checkboxPosition === 'start') {
  <mat-checkbox
    class="checkbox-item_checkbox"
    name="{{ text | translate }}"
    [checked]="checked"
    [disabled]="disabled"
    [indeterminate]="indeterminate"></mat-checkbox>
}
<div
  class="checkbox-item_text"
  [class.checkbox-item_text--hover-enabled]="hoverEnabled"
  [class.checkbox-item_text--disabled]="disabled"
  matTooltip="{{ showToolTip ? (text | translate) : undefined }}">
  {{ text | translate }}
</div>
<div class="checkbox-item_text-additional">{{ additionalText | translate }}</div>
<ng-content select="[right-content]"></ng-content>

@if (orientation === 'row' && checkboxPosition === 'end') {
  <mat-checkbox
    class="checkbox-item_checkbox"
    name="{{ text | translate }}"
    [checked]="checked"
    [disabled]="disabled"
    [indeterminate]="indeterminate"></mat-checkbox>
}
